<template>
  <div class="product-item">
    
  </div>
</template>

<script>
export default {
  name: 'productItem',
  components: {},
  props: {
    items: {
      type: Object
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang='less' scoped>
.product-item {
}
</style>


// WEBPACK FOOTER //
// src/components/productItem.vue